goog.provide('el8.appchart.dialog.ordermed.discontinue');

goog.require('el8.appchart.dialog.ordermed.discontinueFormDialog');


el8.appchart.dialog.ordermed.discontinue = (function() {

    var that = new el8.appchart.dialog.ordermed.discontinueFormDialog({
        title: 'Reason for Discontinuing Med',
        autoHeight: true,
        width: 400,
        isDocumented: false
    });

    return that;
    
})();
